import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFiltersInPage } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { MilestoneFragnetFilter } from 'components/common/GlobalFiltersInPage/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { GlobalFilterFieldKey } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader } from 'components/common';
import { ActivitiesPredecessors } from 'components/widgets/ActivityCompletionPlan/ActivitiesPredecessors';

export const CompletionPlanPage = () => {
    useFullStoryPageView({ pageName: executionConfig.completionPlan.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <GlobalFilterButton />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.completionPlan.title} />
                    <GlobalFiltersInPage defaultValues={{ [GlobalFilterFieldKey.milestoneFragnet]: null }}>
                        <MilestoneFragnetFilter name={GlobalFilterFieldKey.milestoneFragnet} />
                    </GlobalFiltersInPage>
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <ActivitiesPredecessors />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={['activityCompletionPlan']} />
        </PageContainer>
    );
};
